import { REPORT_JOB } from "constants/actionTypes";
import { ReportJobAction } from "./reportJob";

export interface CompileReportJobAction {
  type: typeof REPORT_JOB.COMPILE.ACTION;
  reportJobIds: string[];
}

ReportJobAction.compile = (reportJobIds: string[]): CompileReportJobAction => ({
  type: REPORT_JOB.COMPILE.ACTION,
  reportJobIds,
});

export interface BulkExportReportJobSuccessAction {
  type: typeof REPORT_JOB.BULK_EXPORT.SUCCESS;
  successUrl: string;
}

export interface BulkExportReportJobFailureAction {
  type: typeof REPORT_JOB.BULK_EXPORT.FAILURE;
  status: number;
  statusText: string;
}

export interface BulkExportReportJobAction {
  type: typeof REPORT_JOB.BULK_EXPORT.REQUEST;
  reportJobIds: string[];
}

ReportJobAction.bulkExport = (
  reportJobIds: string[],
): BulkExportReportJobAction => ({
  type: REPORT_JOB.BULK_EXPORT.REQUEST,
  reportJobIds,
});
